// extracted by mini-css-extract-plugin
export default {"modal":"V2vjqc71SQQ7xM7NqY6D","titleWrapper":"iSbawemTXu0GyyaUQB68","paymentsDoneAlert":"V_pxxp0XOmo1SDUZmmJ2","resetToOriginalAmountButton":"bNjhCWXtaz_bbeoxlLEW"};